import { clear, unprefix } from '../../../helpers/compact';
import { toImage } from '../fields/image';
import { toText } from '../fields/text';
import { author } from './author';
import { caption } from './caption';

export const video = (data) => {
  const {
    frame: { embed_url } = {},
    title,
    desc,
    transcription,
    preview_image,
    ...rest
  } = unprefix('video', data);
  if (embed_url) {
    return clear({
      src: embed_url,
      desc: toText(desc),
      title: toText(title),
      transcription,
      previewImage: toImage(preview_image),
      caption: caption(rest),
      author: author(rest),
    });
  }
};
